import React, { useEffect } from "react";

// component
import Leftbar from "Components/Common/Leftbar";
import Header from "Components/Common/Header";

// css
import "Assets/css/style.css";
import "Assets/css/booking-form.css";
import "Assets/css/booking-list.css";
import ListOfEquipment from "Components/Core/Equipment/ListOfEquipment";

const index = () => {

  return (
    <>
      <Header />
      <div id="wrapper">
        <Leftbar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <ListOfEquipment />
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
